import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { MenuItem, MenuList, Box, Button } from '@mui/material';
import { ArrowDropDown as ArrowDownIcon } from '@mui/icons-material';

import { useAuth, AuthCompanyContext } from '@homesusa/auth';
import { MarketCodeLabel, Company, RoleUser } from '@homesusa/core';
import { MarketMenu, marketMenuClasses, MenuStyled } from './header-user.style';
import { buttonGroupClasses } from './header-user.style';
import { AnchorEl } from './use-anchor-el';

const menuId = 'company-menu-appbar';
export function CompanyButton({ anchor: anchor }: { anchor: AnchorEl }): JSX.Element {
  const { currentCompany, currentMarket } = React.useContext(AuthCompanyContext);

  return (
    <Button aria-controls={menuId} onClick={anchor.handleClick} endIcon={<ArrowDownIcon />}>
      {currentCompany?.logoUri ? (
        <img src={currentCompany.logoUri} className={buttonGroupClasses.logo} />
      ) : !!currentCompany ? (
        currentCompany.name
      ) : !!currentMarket ? (
        `All - ${MarketCodeLabel.get(currentMarket)}`
      ) : null}
    </Button>
  );
}

export function CompanyButtonMenu({
  companies,
  anchor
}: {
  companies: Company[];
  anchor: AnchorEl;
}): JSX.Element {
  const { setCurrentCompany, currentCompany, currentMarket } = React.useContext(AuthCompanyContext);
  const { user: userProfile } = useAuth();
  const marketName = MarketCodeLabel.get(currentMarket) ?? currentMarket;
  const navigate = useNavigate();

  const anyCompanyHasLogo = React.useMemo(() => {
    return companies?.some((c) => !!c.logoUri) ?? false;
  }, [companies]);

  if (!companies) {
    return <Fragment></Fragment>;
  }

  return (
    <MenuStyled
      anchorEl={anchor.anchorEl}
      open={anchor.open}
      onClose={anchor.handleClose}
      keepMounted
      id={menuId}
    >
      <MarketMenu className={marketMenuClasses.root}>
        <MenuList>
          {userProfile?.role != RoleUser.User && (
            <MenuItem
              onClick={(): void => {
                setCurrentCompany(null, currentMarket)
                  .then(() => anchor.handleClose())
                  .finally(() => navigate('/'));
              }}
              className={marketMenuClasses.company}
            >
              All - {marketName}
            </MenuItem>
          )}
          {companies.map((company) => (
            <MenuItem
              key={company.id}
              onClick={(): void => {
                setCurrentCompany(company)
                  .then(() => anchor.handleClose())
                  .finally(() => navigate('/'));
              }}
              className={marketMenuClasses.company}
              selected={currentCompany?.id == company.id}
            >
              <Box className={anyCompanyHasLogo ? marketMenuClasses.companyLogo : undefined}>
                {company.logoUri && (
                  <Box className={marketMenuClasses.companyLogoContent}>
                    <Box component='img' src={company.logoUri} />
                  </Box>
                )}
              </Box>
              {company.name} - {marketName}
            </MenuItem>
          ))}
        </MenuList>
      </MarketMenu>
    </MenuStyled>
  );
}
